import React from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from '../use.store';
import ImageChecker from './ImageChecker';
import ProgressBar from './ProgressBar';
import Star from '../assets/star.svg';
import Loader from './Loader';

const Loading = observer(() => {
    const { mainStore } = useStores();

    if (mainStore.progressLoadApp === 100) return null;

    return (
        <div className="Loading relative absolute z-[99] top-0 left-0 w-full h-full flex-1 flex flex-col justify-between items-center bg-white">
            <Loader />
            {/* <div className="relative flex flex-col justify-center items-center gap-6 sm:gap-16 h-full -mt-10 w-full">
                {mainStore.logo && (
                    <ImageChecker
                        src={`information/${mainStore.logo}`}
                        alt="logo"
                        className="px-10 
                        w-[240px] h:auto
                        sm:w-[360px]"
                        useDefault={false}
                    />
                )}
                <div
                    className="relative flex flex-col justify-center items-center 
                    gap-[6px] sm:gap-3"
                >
                    <ProgressBar percentage={mainStore.progressLoadApp} />
                    <div
                        className="flex items-center gap-4 rounded-full text-[#4E4E4E] text-center font-regular px-3
                        text-xs sm:text-xl"
                    >
                        {mainStore.progressLoadApp}% Preparing your experience..
                    </div>
                </div>
            </div>
            <img
                src={Star}
                className="absolute -bottom-[80px] -left-[60px] 
                w-[240px] h:auto
                sm:w-[200px]
                sm:h-sm:w-[160px]
                sm:h-md:w-[200px]
                sm:h-lg:w-[240px]"
            /> */}
        </div>
    );
});

export default Loading;
